(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["known-from"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('scroll', function() { 
          const section = document.querySelector('.press-static-section');
          const sectionPosition = section.getBoundingClientRect().top;
          const screenPosition = window.innerHeight / 1.5;
  
          if(sectionPosition < screenPosition) {
              section.style.opacity = '1';
          } 
  
          const members = document.querySelectorAll('.press-static-logo img');
          members.forEach((member, index) => {
              if(sectionPosition < screenPosition) {
                  setTimeout(() => {
                      member.style.opacity = '1';
                      member.style.transform = 'translateY(0px)';
                  }, 150 * index); 
              }
          });
      });
  
  } catch(e) { console.error(e); }
})();
})();
